
// react
import React from 'react'

// Appt
import Text from '../../simple/text/Text'

import ActionButton from '../actionButton/ActionButton'

import { VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import moment from 'moment'
import FontAwesome from '../fontAwesome/FontAwesome'
import LocalStorageService from '../../../services/LocalStorageService'
import { getRecordTerm } from '../../../services/TermsService'

/**
 * `TimelineCard` renders a specific Layer
 */
function TimelineCard(props) {

   const { record } = props;
  const terms = LocalStorageService.get('terms')

   let color = '#ff8300'
   let otherColor = '#04124C'

   let title = ''
   let subtitle = ''
   let description = ''
   let icon = ['fal', 'print']

   let authorName = ''
   if (record?.authorFirstName || record?.authorLastName) {
     authorName = `Recorded by ${record?.authorFirstName || ''} ${record?.authorLastName || ''}`.trim()
   }

  let studentName = ''
   if (record?.studentFirstName || record?.studentLastName) {
     studentName = 'For ' + `${record?.studentFirstName || ''} ${record?.studentLastName || ''}`.trim()
   }

   let link = ''
   let linkText = ''

   subtitle = authorName?.length > 0 ? authorName : studentName

   switch (record?.type) {

    case 'incidentreport':
        // color = '#ff8300'
        // otherColor = '#04124C'
       title = record.subType === 'highlevel'
         ? getRecordTerm(terms, 'physicalReportTerm', 'Physical Intervention Report')
         : getRecordTerm(terms, 'incidentReportTerm', 'Incident Report')
        description = record.description
        icon = ['fal', 'exclamation-circle']
       linkText = `View`
        link = `/incident/${record.subType === 'highlevel' ? 'high-level/' : '' }${record.subject}/edit/${record.id}`
        if (record?.pdfUrl) {
            link = `/pdfviewer?url=${encodeURIComponent(record.pdfUrl)}`
        }
        break;

    case 'behaviourplan':
       title = `${getRecordTerm(terms, 'smartPlanBuilderTerm', 'Smart Plan')} Created`
        icon = ['fal', 'clipboard-list-check']
        if (record?.pdfUrl) {
          linkText = `View ${getRecordTerm(terms, 'smartPlanBuilderTerm', 'Smart Plan')}`
            // link = record.pdfUrl
            link = `/pdfviewer?url=${encodeURIComponent(record.pdfUrl)}`
        }
        break;

    case 'concern':
       title = `${getRecordTerm(terms, 'communicationTerm', 'Communication')} Raised`
       icon = ['fal', 'info-circle']
       description = record.description
       break;

    case 'clicker':
        title = record.subType ? `"${record.subType}" Recorded` : 'Clicker Entry'
        icon = ['fa', 'flag']
        break;
   }

  return (
    <VerticalTimelineElement
        className="vertical-timeline-element"
        contentStyle={{ background: `${color}`, color: otherColor, borderRadius: '8px' }}
        contentArrowStyle={{ borderRight: `7px solid  ${color}` }}
        date={<Text weight='bold'>{moment(record?.createdAt).format('MMMM DD, YYYY - dddd HH:mm')}</Text>}
        iconStyle={{ background: `${color}`, color: otherColor }}
        icon={<Text align='center'><FontAwesome icon={icon} size='lg' /></Text>}
    >
        <h3 className="vertical-timeline-element-title">{title}</h3>
        <h4 className="vertical-timeline-element-subtitle">{subtitle}</h4>
        <p style={{ flex: 'grow', width: '100%' }}>
            {description}
        </p>
        {link && <ActionButton secondary labelIcon={['fal', 'eye']} label={linkText} onClick={() => window.location.href = link} margin={{ top: 'medium', bottom: 'none' }} />}
    </VerticalTimelineElement>
  )
}

export default TimelineCard
